import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-alerta-exclusao-beneficio',
    templateUrl: './alerta-exclusao-beneficio.component.html',
    styleUrls: ['./alerta-exclusao-beneficio.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertaExclusaoBeneficioComponent {

  @Input() showAlertaExclusaoBeneficio: boolean;
  @Input() indexBeneficio: any;
  @Output() alertaExclusaoBeneficioFechou = new EventEmitter();

  constructor() {
  }

  cancelaExclusao() {
    this.alertaExclusaoBeneficioFechou.emit(-1);
  }

  confirmaExclusao() {
    this.alertaExclusaoBeneficioFechou.emit(this.indexBeneficio);
  }
}
